import React, { useState, useEffect } from "react";
import "./LinkModal.css";

export default function LinkModal({ isOpen, onClose, initialLink, onSave, onDelete }) {
  const [name, setName] = useState("");
  const [link, setLink] = useState("");

  useEffect(() => {
    if (initialLink) {
      setName(initialLink.name || "");
      setLink(initialLink.link || "");
    } else {
      setName("");
      setLink("");
    }
  }, [initialLink, isOpen]);

  const handleSave = () => {
    if (!name.trim() || !link.trim()) {

      return;
    }
    onSave({ name: name.trim(), link: link.trim() });
    onClose();
  };

  if (!isOpen) return null;

  return (
    <div className="link-modal-overlay" onClick={onClose}>
      <div className="link-modal-content" onClick={(e) => e.stopPropagation()}>
        <div className="link-modal-header">
          <h2>{initialLink ? "Link bearbeiten" : "Link hinzufügen"}</h2>
          <button className="link-modal-close" onClick={onClose}>✖</button>
        </div>

        <div className="link-modal-body">
          <label>Name</label>
          <input
            type="text"
            value={name}
            onChange={(e) => setName(e.target.value)}
            placeholder="z.B. Website, LinkedIn, etc."
          />

          <label>Link</label>
          <input
            type="url"
            value={link}
            onChange={(e) => setLink(e.target.value)}
            placeholder="https://..."
          />

          <div className="link-modal-actions">
            {initialLink && onDelete && (
              <button className="delete-btn" onClick={() => {
                onDelete(initialLink.id);
                onClose();
              }}>
                Entfernen
              </button>
            )}
            <button className="save-btn" onClick={handleSave}>Speichern</button>
            <button className="cancel-btn" onClick={onClose}>Abbrechen</button>
          </div>
        </div>
      </div>
    </div>
  );
}
